package com.karawek.core.auth.util

import com.karawek.core.auth.api.Authenticator
import com.karawek.core.auth.api.AuthSessionStore
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@Inject
@SingleIn(AppScope::class)
class AuthNavigationUtils(
    private val authenticator: Authenticator,
    private val sessionStore: AuthSessionStore,
) {

    suspend fun resolveStartScreen(
        authenticated: () -> Screen,
        unauthenticated: () -> Screen,
    ): Screen =
        if (sessionStore.read() != null) {
            authenticated()
        } else {
            unauthenticated()
        }

    suspend fun logout() {
        runCatching {
            authenticator.signOut()
        }
        sessionStore.clear()
    }
}
